import { render, staticRenderFns } from "./AddCourseModal.vue?vue&type=template&id=237f0a78&"
import script from "./AddCourseModal.vue?vue&type=script&lang=js&"
export * from "./AddCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports